.card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  font-family: var(--token-font-ui);
}

.cardArchived {
  opacity: 0.7;
}

/* ---------- themed card: live theme art behind readable text ---------- */

.bgLayer {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
}

/* Readability scrim. Darker on the left (where the name + meta sit) and
 * lighter toward the mascot on the right, plus a small overall darken so
 * white text clears WCAG contrast over any theme background. */
.scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    100deg,
    rgba(8, 14, 12, 0.72) 0%,
    rgba(8, 14, 12, 0.55) 42%,
    rgba(8, 14, 12, 0.22) 100%
  );
}

/* Lift the actual content above the art + scrim. */
.cardThemed .cardButton,
.cardThemed .cardFooter {
  position: relative;
  z-index: 2;
}

.cardThemed .cardName {
  color: #fff;
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.55);
}

.cardThemed .cardMeta {
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
}

.cardThemed .cardYear {
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
}

.cardThemed .cardButton:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
}

.cardThemed .activateButton {
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.45);
}

.cardThemed .activateButton:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.cardThemed .archiveButton {
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.45);
}

.cardThemed .archiveButton:hover:not(:disabled) {
  color: #fff;
  background: rgba(255, 255, 255, 0.16);
}

.cardButton {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 18px 18px 24px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
  width: 100%;
  transition: background 120ms ease;
}

.cardText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.cardMascot {
  display: block;
  width: 64px;
  height: 64px;
  object-fit: contain;
  flex-shrink: 0;
  filter: drop-shadow(0 4px 8px rgba(8, 18, 12, 0.18));
  user-select: none;
  -webkit-user-drag: none;
}

.cardButton:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
}

.cardButton:disabled {
  cursor: default;
}

.cardName {
  font-family: var(--token-font-display);
  font-size: 22px;
  color: var(--token-text-primary);
  letter-spacing: 0.2px;
}

.cardMeta {
  font-size: 14px;
  color: rgba(28, 38, 32, 0.78);
}

.cardYear {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(28, 38, 32, 0.6);
}

.cardFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 8px 14px 14px;
}

.activateButton {
  border: none;
  background: transparent;
  color: var(--token-accent);
  font-family: var(--token-font-ui);
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.2px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 999px;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.activateButton:hover:not(:disabled) {
  background: color-mix(in srgb, var(--token-accent) 16%, transparent);
  color: #c1772f;
}

.archiveButton {
  border: none;
  background: transparent;
  color: rgba(28, 38, 32, 0.6);
  font-family: var(--token-font-ui);
  font-size: 13px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 999px;
  transition:
    color 120ms ease,
    background 120ms ease;
}

.archiveButton:hover:not(:disabled) {
  color: var(--token-text-primary);
  background: rgba(8, 18, 12, 0.06);
}
